import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, {
  init,
  submitAndQueryResult,
} from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const OrderDetails = Loadable({
    loader: () => import('./OrderDetails'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          cryptoPayOrderDetailsState: state.cryptoPayOrderDetailsState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          submitAndQueryResult,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={route.match.path}
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <OrderDetails {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
